import store from '../../../stores'
export const pdfPrintMixin = {
  methods: {
    changeReportTitle(reportType) {
      if (this.$checkMaintence(this.Userinfo)) {
        switch (reportType) {
          case '00':
            return '契約內容一覽表(完整版)';
            break;
            case '22':
              return '契約內容一覽表-國泰產險含筆記(完整版)';
                  break;
                case '18':
                  return '當年度保障總覽(個人版)';
                  break;
                  case '02':
                    return '當年度保障總覽(完整版-多張)';
                  break;
                case '03':
                  return '當年度保障明細(完整版-多張)';
                  break;
                case '15':
                  return '其他保障明細(搭配完整版)';
                  break;
                case '01':
                  return '契約內容一覽表(精簡版)';
                  break;
                case '23':
                  return '契約內容一覽表-國泰產險含筆記(精簡版)';
                  break;
                case '04':
                  return '當年度保障總覽(精簡版-一張)';
                  break;
                case '05':
                  return '當年度保障明細(精簡版-一張)';
                  break;
                case '17':
                  return '其他保障明細(搭配精簡版)';
                  break;
                case '06':
                  return '逐月保費一覽表';
                  break;
                case '07':
                  return '逐年保費預估表總覽';
                  break;
                case '08':
                  return '逐年保費預估表明細';
                  break;
                case '09':
                  return '身故/完全失能 保障總覽';
                  break;
                case '10':
                  return '身故/完全失能 逐年保障明細表';
                  break;
                case '11':
                  return '基本醫療保障期間表';
                  break;
                case '12':
                  return '滿期金或年金領回總覽';
                  break;
                case '13':
                  return '滿期金或年金領回明細表';
                  break;
                case '14':
                  return '投資型專用報表';
                  break;
                case '16':
                  return '團險保障明細表';
                  break;
                case '19':
                  return '團險/意外險當年度保障明細(完整版-多張)';
                  break;
                case '20':
                  return '團險/意外險當年度保障總覽(完整版-多張)';
                  break;
                case '21':
                  return '團險/意外險其他保障明細(搭配完整版)';
                  break;
              }
            } else {
              switch (reportType) {
                case '00':
                  return '契約內容一覽表(完整版)';
                  break;
				case '22':
                  return '契約內容一覽表-國泰產險含筆記(完整版)';
                  break;
                case '18':
                  return '當年度保障總覽(個人版)';
                  break;
                case '02':
                  return '當年度保障總覽(完整版-多張)';
                  break;
                case '03':
                  return '當年度保障明細(完整版-多張)';
                  break;
                case '15':
                  return '其他保障明細(搭配完整版)';
                  break;
                case '01':
                  return '契約內容一覽表(精簡版)';
                  break;
				case '23':
                  return '契約內容一覽表-國泰產險含筆記(精簡版)';
                  break;
                case '04':
                  return '當年度保障總覽(精簡版-一張)';
                  break;
                case '05':
                  return '當年度保障明細(精簡版-一張)';
                  break;
                case '17':
                  return '其他保障明細(搭配精簡版)';
                  break;
                case '06':
                  return '逐月保費一覽表';
                  break;
                case '07':
                  return '逐年保費預估表總覽';
                  break;
                case '08':
                  return '逐年保費預估表明細';
                  break;
                case '09':
                  return '身故/完全失能 保障總覽';
                  break;
                case '10':
                  return '身故/完全失能 逐年保障明細表';
                  break;
                case '11':
                  return '基本醫療保障期間表';
                  break;
                case '12':
                  return '滿期金或年金領回總覽';
                  break;
                case '13':
                  return '滿期金或年金領回明細表';
                  break;
                case '14':
                  return '投資型專用報表';
                  break;
                case '16':
                  return '團險保障明細表';
                  break;
              }
            }
          },
          getUrl(){
            if(store.getters.IsBFF_MV){
              if (window.location.href.indexOf('localhost') !== -1) {
                return 'http://localhost:8089/mid-mxf0-crm-ui';
              } else{
                return `${window.location.origin}/mid-mxf0-crm-ui`;
              }
            }
            if (window.location.href.indexOf('localhost') !== -1) {
              return 'http://localhost:8080/MVWeb';
            } else if (window.location.href.indexOf('tmycrm') !== -1) {
              return 'https://tcrmapi.cathaylife.com.tw/MVWeb';
            } else if (window.location.href.indexOf('smycrm') !== -1) {
              return 'https://scrmapi.cathaylife.com.tw/MVWeb';
            } else if (window.location.href.indexOf('mycrm') !== -1) {
              return 'https://crmapi.cathaylife.com.tw/MVWeb';
            } else {
              return `http://${window.location.href.match(/\d*\.\d*\.\d*\.\d*/g)}:8080/MVWeb`;
            }
          }
    }
};
  